/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState, useRef } from 'react';
import './ButtonCodeRenew.scss';
import { tA11y } from '@utils/a11y/a11yHelpers';
import { getKeyByValue, appIconsPath } from '@utils/globalConstant';
import Icons from '@core/Utils/Icons/Icons';
export function ButtonCodeRenew({
  iconLeft = null,
  iconRight = null,
  label,
  timerText,
  btnRef,
  onClick = () => {},
  // timerSeconds = 30,
  timer,
  ariaLabelButton,
  ariaLabelTimer,
  disabled = false,
  ...restProps
}) {
  const timerRef = useRef(null);

  const buttonCodeIconLeft = getKeyByValue(appIconsPath,iconLeft);
  const buttonCodeIconRight = getKeyByValue(appIconsPath,iconRight);

  useEffect(() => {
    if (timerRef.current) {
      timerRef.current.innerText = `${timer}`;
      timerRef.current.setAttribute('aria-label', ariaLabelTimer);
    }
  }, [timer]);

  return (
    <div
      className="code-renew d-flex align-items-center justify-content-start"
      tabIndex={disabled ? 0 : undefined}
      aria-live="polite">
      <button
        type="button"
        className={`code-renew-btn bg-transparent border-0 p-0 ek-copy-sm-14-medium-underlined text-primary ${
          disabled ? 'disabled' : ''
        }`}
        ref={btnRef}
        onClick={onClick}
        disabled={disabled}
        aria-disabled={disabled}
        aria-label={ariaLabelButton}
        {...restProps}>
        <div className="d-flex">
          {iconLeft && (
            <span className="code-renew-icon pe-8">
              <Icons name={buttonCodeIconLeft} height={18} colorType='dark' />
            </span>
          )}

          {label &&
            (tA11y(label).isHtml ? (
              <span
                className="code-renew-label"
                dangerouslySetInnerHTML={{ __html: tA11y(label).content }}
              />
            ) : (
              <span className="code-renew-label">{tA11y(label).content}</span>
            ))}

          {iconRight && (
            <span className="code-renew-icon pe-8">
              <Icons name={buttonCodeIconRight} height={18} colorType='dark' />
            </span>
          )}
        </div>
      </button>
      {/* {timerText &&
        (tA11y(timerText).isHtml ? (
          <span
            className="ek-copy-sm-14-medium text-primary ps-8"
            dangerouslySetInnerHTML={{
              __html: tA11y(timerText).content.replace(
                '{TIMER}',
                timeLeft !== 0 ? formattedTime : '0:00'
              )
            }}
          />
        ) : (
          <span className="ek-copy-sm-14-medium text-primary ps-8">
            {tA11y(timerText).content.replace('{TIMER}', timeLeft !== 0 ? formattedTime : '0:00')}
          </span>
        ))} */}
      <span className="ek-copy-sm-14-medium text-primary ps-8">
        (
        <span role="timer" ref={timerRef}>
          {timer}
        </span>
        )
      </span>
    </div>
  );
}

export default ButtonCodeRenew;
